// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3W8hC","list":"BalanceDue_list__1AHAk","listRow":"BalanceDue_listRow__21p4t","total":"BalanceDue_total__1ufaS"};